import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaEnvelope, FaPhoneAlt, FaFacebookF, FaTwitter, FaYoutube, FaPinterestP, FaWhatsapp } from 'react-icons/fa';

import { FaRegCalendarAlt } from 'react-icons/fa';

import "./Footer.css";
import logo from '../assets/Zarinova-logo.png';
const Footer = () => {
  return (
    <footer className="bg-dark text-white pt-5 pb-3" style={{ backgroundColor: '#0e061f' }}>
      <Container>
        <Row className="gy-4">
          <Col md={3}>
            <div className="align-items-center mb-3">
      <img src={logo} alt="Zarinova Logo" className="navbar-logo" />
            </div>
            <p className="text-muted1 small">
              Our exceptional team has orchestrated over 100 jubilant weddings and diverse events, earning the trust and joy of our cherished clients. 
            </p>
            <p className="text-muted1 small mb-1">
              <FaEnvelope className="me-2" />
             rahim@zarinova.in
            </p>
            <p className="text-muted1 small">
              <FaPhoneAlt className="me-2" />
              (91)-9657385305/(91)-8483829335
            </p>
          </Col>

          <Col md={2}>
            <h6 className="fw-bold4 mb-3">Quick Links</h6>
            <ul className="list-unstyled text-muted1 medium">
              <li><a href="#" className="text-muted1 text-decoration-none text-white">Homepage</a></li>
              <li><a href="#" className="text-muted1 text-decoration-none text-white">About Us</a></li>
              <li><a href="#" className="text-muted1 text-decoration-none text-white">Our Services</a></li>
              <li><a href="#" className="text-muted1 text-decoration-none text-white">Showcase</a></li>
              <li><a href="#" className="text-muted1 text-decoration-none text-white">Contact Us</a></li>
            </ul>
          </Col>

          <Col md={3}>
            <h6 className="fw-bold4 mb-3">Our Services</h6>
            <ul className="list-unstyled text-muted1 medium">
              <li><a href="#" className="text-muted1 text-decoration-none text-white">Corporate Events</a></li>
  <li><a href="#" className="text-muted1 text-decoration-none text-white">Corporate parties</a></li>
  <li><a href="#" className="text-muted1 text-decoration-none text-white">BTL and ATL</a></li>
  <li><a href="#" className="text-muted1 text-decoration-none text-white">Artist Management</a></li>
  <li><a href="#" className="text-muted1 text-decoration-none text-white">Event Production</a></li>
  <li><a href="#" className="text-muted1 text-decoration-none text-white">
Venue Management</a></li>
  <li><a href="#" className="text-muted1 text-decoration-none text-white">Event Decoration</a></li>
            </ul>
          </Col>

          <Col md={4}>
            <h6 className="fw-bold4 mb-3">Subscribe Our Newsletter</h6>
            <p className="text-muted1 small">Get Our Latest Update & New Offers Sales Discount</p>
            <Form className="d-flex flex-column flex-md-row align-items-center gap-2">

              <Form.Control
                type="email"
                placeholder="Email"
                className="me-2 rounded-pill px-3"
              />
              <Button
                type="submit"
                className="rounded-pill px-4"
                style={{
                  background: 'linear-gradient(to right, #e2b8ff, #f0a1c0)',
                  border: 'none',
                  color: '#000',
                  fontWeight: 'bold'
                }}
              >
                Subscribe
              </Button>
            </Form>
          </Col>
        </Row>

        <hr className="my-4 border-secondary" />
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <p className="text-muted1 small m-0">Copyright ©2024. All rights reserved by Zarinova Entertainment Design by <a
                href="https://www.pawartechnologyservices.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green"
              > PTS</a></p>
        <div className="d-flex footer-social gap-3 mt-3 mt-md-0">
  <a href="#" className="text-muted1 fs-4"><FaFacebookF /></a>
  <a href="#" className="text-muted1 fs-4"><FaTwitter /></a>
  <a href="#" className="text-muted1 fs-4"><FaYoutube /></a>
  <a href="#" className="text-muted1 fs-4"><FaPinterestP /></a>
  <a href="https://wa.me/7210863401" target="_blank" rel="noopener noreferrer" className="text-muted1 fs-4">
    <FaWhatsapp />
  </a>
</div>


        </div>
      </Container>
    </footer>
  );
};

export default Footer;
